import BookAppointmentDialog, { DEFAULT_CALENDLY_BOOK_APPOINTMENT_URL } from '@/components/Onboarding/BookAppointmentDialog.vue';

export default {
  components: {
    BookAppointmentDialog,
  },
  data() {
    return {
      showBookAppointmentDialog: false,
      bookAppointmentCalendlyUrl: DEFAULT_CALENDLY_BOOK_APPOINTMENT_URL,
      pendingBookAppointmentTaskId: null,
      isCompletingBookAppointmentTask: false,
    };
  },
  methods: {
    /**
     * Use onboarding task `link` from Manage only when it is an http(s) URL on calendly.com.
     */
    resolveBookAppointmentCalendlyUrl(task) {
      const raw = task?.link;
      if (typeof raw === 'string') {
        const t = raw.trim();
        if (/^https?:\/\//i.test(t) && t.toLowerCase().includes('calendly.com')) {
          return t;
        }
      }
      return DEFAULT_CALENDLY_BOOK_APPOINTMENT_URL;
    },
    openBookAppointmentDialog(task) {
      if (!task?.id) {
        return;
      }
      // Only complete book appointment onboarding task after Calendly confirms event was scheduled when this task is still incomplete.
      this.pendingBookAppointmentTaskId = task.complete ? null : task.id; // If task is complete, don't complete it again.
      this.bookAppointmentCalendlyUrl = this.resolveBookAppointmentCalendlyUrl(task);
      this.showBookAppointmentDialog = true;
    },
    /**
     * Completes book appointment onboarding task only after Calendly confirms event was scheduled.
     */
    async completeBookAppointmentAndOpenModal(task) {
      this.openBookAppointmentDialog(task);
    },
    async handleBookAppointmentScheduled() {
      if (!this.pendingBookAppointmentTaskId || this.isCompletingBookAppointmentTask) {
        return;
      }
      this.isCompletingBookAppointmentTask = true;
      try {
        await this.$http.post('/api/v1/onboarding/complete-book-appointment', {
          onboardingTaskId: this.pendingBookAppointmentTaskId,
        });
        this.showBookAppointmentDialog = false;
        if (typeof this.getOnboardingData === 'function') {
          await this.getOnboardingData();
        }
        this.$emit('bookAppointmentCompleted');
        this.$noty.success('Appointment scheduled. Task marked complete.');
        
      } catch (err) {
        console.error('complete-book-appointment failed:', err);
        this.$noty.error('Appointment was scheduled, but we could not mark the task complete. Please refresh and try again.');
      } finally {
        this.isCompletingBookAppointmentTask = false;
        this.pendingBookAppointmentTaskId = null;
      }
    },
    handleBookAppointmentClosed() {
      if (this.isCompletingBookAppointmentTask) {
        return;
      }
      this.pendingBookAppointmentTaskId = null;
      this.bookAppointmentCalendlyUrl = DEFAULT_CALENDLY_BOOK_APPOINTMENT_URL;
    },
  },
};
